import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function TwoColumnTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden" data-testid="resume-live-preview">
      <div className="p-6 border-b" style={{ borderColor: `${accent}40` }}>
        <h1 className="text-2xl font-bold" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
        <p className="text-slate-500 text-xs mt-0.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        {draft.target_role && <p className="text-slate-600 text-xs mt-0.5">{draft.target_role}</p>}
      </div>
      <div className="grid grid-cols-[60%_40%]">
        <div className="p-6">
          {draft.summary && (
            <div>
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Summary</h2>
              <p className="text-slate-700 mt-1">{draft.summary}</p>
            </div>
          )}
          {draft.experience.length > 0 && (
            <div className="mt-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
              {draft.experience.map((e, i) => (
                <div key={i} className="mt-2">
                  <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                  <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="p-6" style={{ backgroundColor: `${accent}0d` }}>
          {draft.skills.length > 0 && (
            <div>
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Skills</h2>
              <ul className="mt-1.5 space-y-1">{draft.skills.map((sk) => <li key={sk} className="text-slate-700 text-[11px]">{sk}</li>)}</ul>
            </div>
          )}
          {draft.education.length > 0 && (
            <div className="mt-4">
              <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
              {draft.education.map((ed, i) => <p key={i} className="text-slate-700 text-[11px] mt-1.5">{ed.degree} {ed.field}<br />{ed.school}</p>)}
            </div>
          )}
          <ExtraResumeSections draft={draft} accent={accent} />
        </div>
      </div>
    </div>
  );
}
